import React from 'react';
import { fileFromClipboardImage } from '../utils/clipboardImage';

/**
 * Textarea that accepts normal text paste and routes image paste to attachments.
 */
export default function PasteScreenshotTextarea({ onScreenshotPaste, onPaste, ...props }) {
  const handlePaste = (event) => {
    const imageFile = fileFromClipboardImage(event.clipboardData);
    if (imageFile) {
      event.preventDefault();
      onScreenshotPaste?.(imageFile);
      return;
    }

    onPaste?.(event);
  };

  return <textarea {...props} onPaste={handlePaste} />;
}
